import React, { Fragment, useEffect, useState, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import AddIcon from '@material-ui/icons/Add';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../../styles/colors';
import ButtonContent from '../ButtonContent';
import { faTrash, faPlus, faCheck } from '@fortawesome/free-solid-svg-icons'
import { ConfirmJsMessage } from '../../helpers.js';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { AlertJsMessage } from './../../helpers.js';
import MileStoneListing from './../assignments/MileStoneListing';

const makeid = (length) => {
    var result = '';
    var characters = '0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

const MileStones = props => {
	const {
		clientEmail,
        fetchMileStones,
        saveMileStones,
        deleteMileStones,
        updateActionStatus
	} = props;

	const [list, setList] = useState([{
        title: '',
        clientId: makeid(10),
        isDelete: false
    }]);

    const [oldList, setOldList] = useState([]);

    const [isFetchRes, setFetchRes] = useState(false);

    const [isOpenViewAction, setOpenViewAction] = useState(false);
  
	useEffect(() => {
	   fetchData()
	}, [clientEmail])

    const fetchData = () => {
        fetchMileStones({
            clientEmail
        }).then((res) => {
            const data = Object.values(res);
            let list = data[0]['data']
            list = list.map((l) => {
                return {
                    ...l,
                    isDelete: false,
                    clientId: makeid(10),
                    isCompleted: l.isCompleted 
                }
            })
            if (list.length === 0) {
                list.push({
                    title: '',
                    clientId: makeid(10),
                    isDelete: false
                })
            }
            setList(list);
            setOldList(JSON.parse(JSON.stringify(list)));
        })
    }

    const viewHistory = () => {
        setOpenViewAction(!isOpenViewAction)
    }

    const onChange = (evt, clientId) => {
        const { value } = evt.target
        const updateList = [...list];
        const findIndex = list.findIndex((l) => {
            return l.clientId === clientId
        })
        updateList[findIndex] = {
            ...updateList[findIndex],
            title: value
        }
        setList([...updateList])
    }

    const addMilestone = () => {
        setList([
            ...list,
            {
                title: '',
                clientId: makeid(10),
                isDelete: false
            }
        ])
    }

    const deleteMilestone =  (index) => {
        const updateList = list;
        const filterList = updateList.filter((l) => !l.isDelete)
        if (filterList.length > 1) {
            updateList[index]['isDelete'] = true;
            setList([
                ...updateList
            ])
        }
    }

    const submitData = () => {
        let prepareData = list;
        let updateData = [];
        for(let i = 0; i < prepareData.length; i++) {
            const obj = prepareData[i];
            let data = {}
            if ((obj.isDelete && obj._id) || !obj.isDelete) {
                data = {
                    title: obj.title,
                    _id: obj._id,
                    clientId: obj.clientId,
                    isDelete: obj.isDelete
                }
                updateData.push(data);
            }
        }
        const isMileStone = list.filter((l) => !l.isDelete && l.title === '')
        if(isMileStone.length > 0) {
            AlertJsMessage('Milestone is required.');
            return;
        }
        saveMileStones({
            milestones: updateData,
            clientEmail: clientEmail,
            isDataNotChanged: JSON.stringify(list) == JSON.stringify(oldList)
        })
        .then((res) => {
            fetchData();
        })
    }

    const filterList = list.filter((l) => !l.isDelete)
    
    return (
        <Fragment>
              <div style={{
                                textAlign: 'right'
                            }}>
                        <Button
                            color="primary"
                            onClick={() => viewHistory()}
                            style={{
                                color: COLORS.orange,
                                fontSize: '10px'
                            }}
                        >
                            <ButtonContent text={ !isOpenViewAction ? "View Completed Milestones" : "Back" }  />
                        </Button>
                    </div> 
                    { isOpenViewAction && (
                        <MileStoneListing 
                            fetchMileStones = { fetchMileStones} 
                            clientEmail = { clientEmail}
                            deleteMileStones = { deleteMileStones }
                            updateActionStatus = { updateActionStatus }
                        >
                        </MileStoneListing>) 
                    } 
                     { !isOpenViewAction && (
            <div
					style={{
						marginTop: 25,
					    width: '600px'
					}}
				>
                   
                    {filterList.map((l, index) =>  {
                        return (
                            <Fragment>
                                <div  style={{
                                    marginLeft: '2px',
                                }}>
                                    <Grid container spacing={12}>
                                        <Grid item xs={10}>
                                            <TextField
                                                label="Milestone"
                                                value={l.title}
                                                name="Milestone"
                                                margin="dense"
                                                variant="outlined"
                                                onChange={event => onChange(event, l.clientId)}
                                                inputProps={{
                                                    maxLength: 60,
                                                    disabled: l.isCompleted ? true : false
                                                }}
                                            />
                                        </Grid>
                                        <span
                                                className="link"
                                                style={{ float: 'right', marginTop: '10px', marginLeft: '5px' }}
                                            >
                                            { l.isCompleted ? 
                                                <FontAwesomeIcon onClick={() => deleteMilestone(index)} icon={faCheck} title={'Completed'}
                                                    style={{ marginRight: 5, color: COLORS.orange }} /> :
                                                <FontAwesomeIcon onClick={() => deleteMilestone(index)} icon={faTrash} title={'Delete'}
                                                    style={{ marginRight: 5, color: COLORS.orange }} />
                                            }
                                            </span>
                                        { index === (filterList.length - 1)  &&
                                            <span
                                                className="link"
                                                style={{ float: 'right', marginTop: '10px', marginLeft: '10px' }}
                                            >
                                                <FontAwesomeIcon icon={faPlus} onClick={() => addMilestone()} title={'Add'}
                                                    style={{ marginRight: 5, color: COLORS.orange }} />
                                            </span>
                                        }
                                    </Grid>
                                    
                                    
                                
                                </div>
                            </Fragment>
                        )
                    })

                }
                { filterList.length > 0 &&
                   <div style={{marginTop: '5px'}}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => submitData()}
                        >
                            <ButtonContent
                                text="Submit"
                                icon="chevron-right" />
                        </Button>
                    </div>
                }                                   
            </div>
                     )}
        </Fragment>
    );
};

export default MileStones;



// WEBPACK FOOTER //
// ./src/components/assignments/Milestones.js